export default __webpack_public_path__ + "static/media/kitchen1-768w.d8c86a37.avif";